import React from 'react';
import MUIDataTable from 'mui-datatables';


const options = {
  filterType: 'none',
  selectableRows: 'none',
  download: false,
  search: false,
  print: false,
  filter: false,
  viewColumns: false,
  pagination: false,
  sort: false,
  elevation: 0
};

const SurveyResults = ({question, answer, classes}) => {
  const data = [{ question, answer }];

  const columns = [
    {
      name: 'question',
      label: 'Survey Question'
    },
    {
      name: 'answer',
      label: 'Survey Answer'
    }
  ];

  return (
    <MUIDataTable
      className={`${classes.inheritTable} ${classes.borderTopBold} mt-1`}
      data={data}
      columns={columns}
      options={options}
    />
  );
};

export default SurveyResults;
